export default __webpack_public_path__ + "static/media/esrpnull.1b1cd49a.svg";